import {
  Combobox,
  OptionData,
} from "components/DesignSystem/Combobox/Combobox";
import { useFormikContext } from "formik";
import { MultiValue, SingleValue } from "react-select";
import { CustomField } from "../customField.types";
import { OnLabelResolved } from "../customFieldSelector.types";
import {
  getSelectedComboboxOption,
  resolveSelectedOptionLabel,
} from "../customFieldSelector.utils";
import { useGetCountriesDataQuery } from "store/apis/onboarding";

type CountrySelectorFieldProps = {
  field: CustomField;
  name: string;
  disabled?: boolean;
  onLabelResolved?: OnLabelResolved;
};

export const CountrySelectorField = ({
  field,
  name,
  disabled,
  onLabelResolved,
}: CountrySelectorFieldProps) => {
  const { data: countries = [], isLoading } = useGetCountriesDataQuery();
  const { values } = useFormikContext<Record<string, string | string[]>>();

  const options: OptionData[] = countries.map(
    ({ uuid, name: countryName }) => ({
      label: countryName,
      value: uuid,
    })
  );
  const selectedOption = getSelectedComboboxOption(
    options,
    values[name],
    field.is_multi_select
  );

  const handleChange = (
    option: SingleValue<OptionData> | MultiValue<OptionData>
  ) => {
    const label = resolveSelectedOptionLabel(option);
    if (label) {
      onLabelResolved?.(name, label);
    }
  };

  return (
    <Combobox
      withForm
      name={name}
      label={field.label}
      placeholder={field.placeholder}
      required={field.is_required}
      tooltipText={field.tooltip}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      isLoading={isLoading}
      isMulti={field.is_multi_select}
      isDisabled={disabled}
      menuPortalTarget={document.body}
    />
  );
};
